<template>
    <img class="icon-img" :src="getAttachUrl(imgInfo)" />
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    // 图片id
    attachId: {
      type: [String, Number],
      default: '',
    },
    bizId: {
      type: [String, Number],
      default: '',
    },
    bizType: {
      type: [String],
      default: '',
    },
  },
  watch: {
    attachId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAttach();
        }
      },
    },
    bizId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAttach();
        }
      },
    }
  },
  data() {
    return {
      imgInfo: {},
    };
  },
  methods: {
    getAttach() {
      if (this.attachId) {
        this.$getAttachFile(this.attachId).then((res) => {
          this.imgInfo = res;
        });
      } else {
        this.$getJSON(`${apis.OssAttach}/${this.bizId}/${this.bizType}`).then((res) => {
          this.imgInfo = res.data.length ? res.data[0] : {};
        });
      }

    },

  },
};
</script>

<style lang="scss">

  .icon-img{
    width: 100%;
    height: 100%;
  }

</style>
